import {
  Edit,
  useLocaleState,
  useRecordContext,
  useTranslate,
} from 'react-admin';

import BeaconGroupForm from '../../Common/BeaconGroup/Form';
import { EditProps } from 'ra-ui-materialui/src/types';

const EditTitle = () => {
  const record = useRecordContext();
  const [locale] = useLocaleState();
  const translate = useTranslate();

  const titleText = record?.translations?.name?.[locale] ?? undefined;

  return (
    <span>
      {translate('app.edit.beaconGroup.title')}{' '}
      {titleText ? `"${titleText}"` : ''}
    </span>
  );
};

const EditBeaconGroup = (props: EditProps) => {
  return (
    <Edit actions={false} {...props} title={<EditTitle />} mutationMode={'pessimistic'}>
      <BeaconGroupForm />
    </Edit>
  );
};

export default EditBeaconGroup;
